import { DeleteOutlined, PlusOutlined, EyeOutlined, CopyOutlined, EditOutlined } from '@ant-design/icons'
import { Button, ConfigProvider, message, Modal, Select, Form } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { SearchWrapper, WhiteWrapper } from './crossData.styled'
import { fetchBrandList } from '../../apis/brand'
import CrossDataForm from './CrossDataForm'
import { addCrossDataSource, delCrossDataSource, fetchCrossDataSource, modCrossDataSource } from '../../apis/crossDataSource'
import { constructCrossDataForm, crossDataFormatSave } from '../DashboardSetting/Conf'

function CrossDataSourceSetting (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const params = useParams({ groupId: user?.nowGroup })
  const { handleFetchParams, fetchParams } = params
  const [brandsOption, setBrandsOption] = useState([])
  const [modalData, setModalData] = useState({})
  const [form] = Form.useForm()
  const [crossDataCount, setCrossDataCount] = useState([1])
  const [loading, setLoading] = useState(false)

  const handleDelete = (id, data) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${data.name}`,
      content: `${ln_t('message.confirm.delete')} ${data.name}?`,
      onOk: async () => {
        const result = await delCrossDataSource(id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const handleOpenAdd = () => {
    setModalData({ open: true, addMode: true })
    form.setFieldValue('brandId', fetchParams?.brandId)
  }

  const handleOpenEdit = (data, viewOnly, addMode) => {
    const { brandId, name, joinDataSource } = data
    const joinCount = joinDataSource?.map(i => i.sequence + 1)
    const formVal = { brandId, name, ...constructCrossDataForm(data.joinDataSource) }
    setModalData({ open: true, data, joinCount, viewOnly, addMode })
    form.setFieldsValue(formVal)
    setCrossDataCount(joinCount)
  }

  const apiFunc = async () => fetchCrossDataSource(fetchParams)
  const formatDate = (date, detail) => dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
  const columns = [
    { title: ln_t('util.name'), dataIndex: 'name', sorter: true },
    { title: ln_t('util.brand'), dataIndex: 'brandId', render: e => brandsOption?.find(i => i.value === e)?.label },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', render: e => formatDate(e), sorter: true },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => <div className="action-btn">
        <Button size="small" icon={<EditOutlined />} onClick={() => handleOpenEdit(data)} />
        <Button size="small" icon={<EyeOutlined />} onClick={() => handleOpenEdit(data, true)} />
        <Button size="small" icon={<CopyOutlined />} onClick={() => handleOpenEdit(data, false, true)} />
        <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)} />
      </div>
    }
  ]

  const handleModalClose = refetch => {
    setModalData({ open: false })
    form.resetFields()
    setCrossDataCount([1])
    if (refetch) handleFetchParams('init', {})
  }
  const handleAdd = async reqBody => {
    setLoading(true)
    const res = await addCrossDataSource(reqBody)
    if (res?.status === 200 || res?.status === 201) {
      message.success(ln_t('message.success.create'))
      handleModalClose(true)
    }
    setLoading(false)
  }
  const handleEdit = async reqBody => {
    setLoading(true)
    const res = await modCrossDataSource(modalData?.data?.id, reqBody)
    if (res?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleModalClose(true)
    }
    setLoading(false)
  }
  const handleSubmit = async value => {
    const { name, brandId, source, ...other } = value
    const reqBody = { name, brandId, groupId: user?.nowGroup, ...crossDataFormatSave(other, crossDataCount) }
    modalData?.addMode ? handleAdd(reqBody) : handleEdit(reqBody)
  }

  const getBrands = async () => {
    const result = await fetchBrandList({ maxResults: 1000, sort: '-updatedAt', groupId: adminMode ? undefined : user.nowGroup })
    if (result.status === 200) setBrandsOption(result?.data.map(i => ({ value: i.id, label: i.name, groupId: i.groupId })))
  }
  useEffect(() => {
    getBrands()
  }, [])

  const passProps = { ...props, brandsOption, form, crossDataCount, setCrossDataCount, loading, modalData, handleModalClose }
  return <>
    <WhiteWrapper>
      <h3>{ln_t('sidebar.crossDataSourceSetting')}</h3>
      <SearchWrapper>
        <div className="d-flex">
          <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 0' }}>{ln_t('util.brand')} :</div>
          <Select
            showSearch
            style={{ minWidth: '120px', marginLeft: '8px' }}
            defaultValue="all"
            placeholder={`${ln_t('util.select')} ${ln_t('util.brand')}`}
            options={[{ value: 'all', label: 'ALL' }, ...brandsOption]}
            optionFilterProp="children"
            value={fetchParams?.brandId || 'all'}
            onChange={e => handleFetchParams('add', { brandId: e === 'all' ? undefined : e })}
          />
        </div>
        <Button type="default" icon={<PlusOutlined />} onClick={handleOpenAdd}>
          {ln_t('util.add')} {ln_t('sidebar.crossDataSourceSetting')}
        </Button>
      </SearchWrapper>

      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
      />
    </WhiteWrapper>

    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal
        open={modalData?.open || false}
        onCancel={handleModalClose}
        footer={null}
        destroyOnClose
        title={`${ln_t('util.add')} ${ln_t('sidebar.crossDataSourceSetting')}`}
        width={1000}
        style={{ top: '24px' }}
      >
        <Form form={form} layout="vertical" requiredMark={false} onFinish={handleSubmit} disabled={modalData?.viewOnly}>
          <CrossDataForm {...passProps} />
        </Form>
      </Modal>
    </ConfigProvider>
  </>
}

export default CrossDataSourceSetting
